// extracted by mini-css-extract-plugin
module.exports = {"statusIcon":"terminal-credentials_statusIcon__2L7bI"};